import styled from 'styled-components';
import { ScrollUpButton, ScrollDownButton, Item } from '@radix-ui/react-select';
import { PlusIcon } from '@radix-ui/react-icons';

export const SelectScrollUpButton = styled(ScrollUpButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  background-color: var(--way-palette-white-100);
  color: var(--way-colors-svgColor);
  cursor: default;
`;

export const SelectScrollDownButton = styled(ScrollDownButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  background-color: var(--way-palette-white-100);
  color: var(--way-colors-svgColor);
  cursor: default;
`;

export const CreateOptionItem = styled(Item)`
  color: var(--way-palette-black-60);
  font-style: italic;

  &[data-highlighted] {
    background-color: var(--way-palette-black-10);
  }
`;

export const CreateIcon = styled(PlusIcon)`
  margin-right: 8px;
  color: var(--way-palette-black-60);
`;
